(function (angular) {
	'use strict';

	angular.module('bluemoon.reports.components', ['bmrcReportList', 'bmrcReportEditOptions', 'bm.reporting.components.templates']);
	angular.module('bmrcReportList', ['bento.modern', 'bmrcReportListService', 'bmrcReportGenerateModalService', 'bmpUserSettings', 'bmpGrid']).component('bmrcReportList', {
		restrict: 'E',
		templateUrl: 'src/reporting/list/report-list.html',
		bindings: {
			/**
			 * Expected to have the following callback functions:
			 * @callback: getEditReportOptionsUrl: Returns the URL to the report options editing screen.
			 * The reportId parameter is appended to the returned URL.
			 * @callback: getReportListUrl: Returns the promise for a URL to the report list API.
			 * @callback: getPreviewUrl: Returns the promise for a URL to the secured preview report url API.
			 * @callback: getSecuredReportDownloadUrl: Returns the promise for a URL to the secured report (for downloading) url API.
			 */
			reportController: '='
		},
		controllerAs: 'vm',
		controller: ['$bentoBusyLoader', '$window', '$element', '$scope', 'bmpUserSettings', 'bmrcReportListService', 'bmrcReportGenerateModalService','bmpErrorHandler','$translate',
			function ($bentoBusyLoader, $window, $element, $scope, userSettings, bmrcReportListService, bmrcReportGenerateModalService, bmpErrorHandler, $translate) {
				this.$onInit = function () {
					var vm = this;
					vm.userSettingsKey = 'ReportListGrid_filterComboValue';
					bmrcReportListService.setReportListQuery(function (params, filter) { return vm.reportController.getReportList(params, filter); });
					bmrcReportListService.setSecuredReportPreviewUrl(function (filter, item) { return vm.reportController.getSecuredReportPreviewUrl(filter, item); });
					bmrcReportListService.setSecuredReportDownloadUrl(function (filter, item) { return vm.reportController.getSecuredReportDownloadUrl(filter, item); });
					bmrcReportListService.setSendReportToOnvioDocumentsUrl(function (filter, item) { return vm.reportController.getSendReportToOnvioDocumentsUrl(filter, item); });
					bmrcReportListService.setSendReportToBinderDocumentsUrl(function (filter, item) { return vm.reportController.getSendReportToBinderDocumentsUrl(filter, item); });
					bmrcReportListService.setGetSelectedFolder(function () { return vm.reportController.getSelectedFolder(); });
					bmrcReportListService.createReportComponentDefinition = vm.reportController.getCreateReportComponentDefinition ? vm.reportController.getCreateReportComponentDefinition() : undefined;
					bmrcReportListService.setUseNewAsyncMode( function () { return ('useNewAsyncMode' in vm.reportController ? vm.reportController.useNewAsyncMode() : false); });
					if ('useNewAsyncMode' in vm.reportController ? vm.reportController.useNewAsyncMode() : false) {
                        bmrcReportListService.setProcessCreateDocumentRequestToSocketSrv(function (jobId, isSubscribe) { return vm.reportController.processCreateDocumentRequestToSocketSrv(jobId, isSubscribe); });
                        bmrcReportListService.setCreateDocumentRequestUrl(function () { return vm.reportController.getCreateDocumentRequestUrl(); });
                        bmrcReportListService.setSocketServicePromise(function () { return vm.reportController.getSocketServicePromise(); });
                        bmrcReportListService.setCreateDocumentApipromise(function () { return vm.reportController.getCreateDocumentApipromise(); });
                        bmrcReportListService.setCloseSocketConnection(function () { return vm.reportController.closeSocketConnection(); });
                        bmrcReportListService.setInsertIntoSocketSrvTracing(function (jobId, payload) { return vm.reportController.insertIntoSocketSrvTracing(jobId, payload); });
                    }
					vm.repository = bmrcReportListService;
					/**
					 * An application that uses the report list control will have wrapped the
					 * options control in an app-specific html page with its own rules for invoking it.
					 * It's likely that the report ID will be appended as a parameter, but we're not
					 * going to dictate that here.  There may be other app-specific things going on,
					 * so let it build the URL.
					 */
					var buildEditReportOptionsUrl = function (reportId) {
						return vm.reportController.getEditReportOptionsUrl(reportId); // TODO - ng161 - handle reject; what should return on reject?
					};

					var syncPreview = function ($item) {
						var busyLoader = $bentoBusyLoader.getNewLoader($element.find('.bmp-list'));
						busyLoader.show().then(function() {
							var newAriaLabelForLoader = $element.find('.bento-busyloader-blocker')[0].ariaLabel + ' ' + $translate.instant('Bluemoon.Reporting.OpeningContentInNewTab');
							$element.find('.bento-busyloader-blocker')[0].setAttribute('aria-label', newAriaLabelForLoader);
						});
						var urlPromise = vm.repository.getSecuredReportPreviewUrl($item);
						urlPromise.then(function (url) {// TODO - ng161 - handle reject
							if (!url.match(/^blob:/)) {
								url = url + '&reportDefinitionId=' + $item.id;
							}
							window.open(url, '_blank');
							vm.definition.loading = false;
						}).finally(function () {
							busyLoader.hide();
						});
					};

					var asyncPreview = function ($item) {
						var busyLoader = $bentoBusyLoader.getNewLoader($element.find('.bmp-list'));
						busyLoader.show().then(function() {
							var newAriaLabelForLoader = $element.find('.bento-busyloader-blocker')[0].ariaLabel + ' ' + $translate.instant('Bluemoon.Reporting.OpeningContentInNewTab');
							$element.find('.bento-busyloader-blocker')[0].setAttribute('aria-label', newAriaLabelForLoader);
						});
                        // initilalize promises
                        bmrcReportListService.getSocketServicePromise().then(function (response){
                            if (response.hasOwnProperty('preview') && response.hasOwnProperty('jobId')) {
                                var urlPromise = bmrcReportListService.getSecuredReportPreviewUrlForAsync($item, response.jobId);
                                urlPromise.then(function (response) {
                                    if(response){
                                        vm.definition.loading = false;
                                    } else {
                                        bmpErrorHandler.processErrors(null, $translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError'));
                                    }
                                }).finally(function () {
                                    busyLoader.hide();
                                    bmrcReportListService.closeSocketConnection();
                                });
                            } else {
                                bmpErrorHandler.processErrors(null, $translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError'));
                                busyLoader.hide();
                                bmrcReportListService.closeSocketConnection();
                            }
                        });

                        bmrcReportListService.getCreateDocumentApipromise().then(function (response){
                            if (response.hasOwnProperty('postRequestBody') && response.hasOwnProperty('jobId')) {
                                response.postRequestBody.jobId = response.jobId;
                                bmrcReportListService.postCreateDocumentRequest(response.postRequestBody, false).then(function(response) {
                                    if(response === null) {
                                        busyLoader.hide();
                                        bmrcReportListService.closeSocketConnection();
                                    }
                                }, function() {
                                    bmrcReportListService.getProcessCreateDocumentRequestToSocketSrv(response.jobId, false);
									busyLoader.hide();
                                });
                            }
                        });

						var body = {
							reportDefinitionId: $item.id,
							reportOutputTypeId: 'PDF',
                            sendToDms: false,
							isDownload: false,
                            isPreview: true
						};
						bmrcReportListService.postCreateDocumentRequest(body, true).then(function(response) {
							if(response === null) {
								busyLoader.hide();
								bmrcReportListService.closeSocketConnection();
							}
						},
						function () {
							busyLoader.hide();
						});
					};

					userSettings.loadSettings().then(function () { // TODO - ng161 - handle reject
						var toolbarFilterCombo = vm.reportController.getToolbarFilterComboDefinition ? vm.reportController.getToolbarFilterComboDefinition() : undefined;
						if (toolbarFilterCombo) {
							var value = toolbarFilterCombo.value;
							if (!value) {
								// If nothing came in, get it from the local storage
								value = userSettings.get(vm.userSettingsKey);
							} else {
								// If something came in, save it to the local storage as the last used one.
								userSettings.set(vm.userSettingsKey, angular.isString(value) ? value : value.id);
							}

							Object.defineProperty(toolbarFilterCombo, 'value', {
								get: function () {
									return value;
								},
								set: function (newValue) {
									if (angular.equals(value, newValue)) {
										return;
									}
									value = newValue;
									if (value.id) {
										userSettings.set(vm.userSettingsKey, value.id);
									}
								}
							});
							vm.repository.toolbarFilterCombo = toolbarFilterCombo;
						}
						var columns = [
							{
								title: /* i18nextract */'Bluemoon.Reporting.Captions.Name',
								dataProperty: 'name',
								search: true,
								shrink: true,
								wrap: false,
								width: '*'
							},
							{
								title: /* i18nextract */'Bluemoon.Reporting.Captions.Type',
								dataProperty: 'reportCategoryType.name',
								search: true,
								wrap: false,
								shrink: true,
								width: '*'
							},
							{
								title: /* i18nextract */'Bluemoon.Reporting.Captions.LastPrinted',
								dataProperty: 'dateLastPrinted',
								sortable: false,
								search: false,
								wrap: false,
								shrink: true,
								width: '*'
							},
						];

						if (vm.reportController.onInitializingColumns) {
							vm.reportController.onInitializingColumns(columns);
                        }

                        //defaults for open the edit report option is a link
                        var openEditReportOptionInDialog = vm.reportController.getEditButtonOption ? vm.reportController.getEditButtonOption() : false;

						vm.definition = {
							gridName: 'ReportListGrid',
							ariaLabel: /* i18nextract */'Bluemoon.Shell.Navigation.FirmManagementReports',
							analyticsContext: 'report_list',
							primaryKey: 'reportId',
							expansions: undefined,
							addButton: false,
							deleteButton: false,
							exportButton: true,
							editButton: false,
							toolbarFilterCombo: toolbarFilterCombo,
							toolbarButtons: [
								{
									id: 'create',
									label: /* i18nextract */'Bluemoon.Reporting.Actions.Create',
									requireItem: true,
									onClick: function ($item) {
										bmrcReportGenerateModalService.showDialog($item, vm.repository);
									},
									icon: 'bento-icon-group'
								}
							],
							actionsColumnIcons: [
								/**
								 * Handles going to the report options screen for the selected report.
								 */
								{
									id: 'edit',
									label: /* i18nextract */'Bluemoon.Reporting.Actions.Edit',
									itemType: openEditReportOptionInDialog ? 'button' : 'link',
									href: !openEditReportOptionInDialog ? function ($item) {
										return buildEditReportOptionsUrl($item);
									} : undefined,
									onClick: openEditReportOptionInDialog ? function ($item) {
										return buildEditReportOptionsUrl($item);
									} : undefined,
									icon: 'bento-icon-edit'
								},
								{
									id: 'open',
									label: /* i18nextract */'Bluemoon.Reporting.Actions.Open',
									itemType: 'button',
									onClick: function ($item) {
										if ('useNewAsyncMode' in vm.reportController ? vm.reportController.useNewAsyncMode() : false) {
											asyncPreview($item);
										} else {
											syncPreview($item);
										}
									},
									icon: 'bento-icon-newtab',
									isDisabled: function ($item) {
										if ($item.systemId === 'CLIENTDIRECTORYWITHCUSTOMFIELDS'){
											return true;
										}
										return false;
									}
								},
								{
									id: 'create',
									label: /* i18nextract */'Bluemoon.Reporting.Actions.Create',
									itemType: 'button',
									onClick: function ($item) {
										bmrcReportGenerateModalService.showDialog([$item], vm.repository);
									},
									icon: 'bento-icon-group'
								}
							],
							orderBy: 'name',
							columns: columns
						};
					});
				};

                this.$onDestroy = function () {
                    if (bmrcReportListService.getUseNewAsyncMode()){
                        bmrcReportListService.closeSocketConnection();
                    }
                };
			}]
	});
})(window.angular);
